// External JS
import {MzcOAuthPortal} from '@zyxel-nebula/mzc-oauth';

console.info('welcome to', process.env.SERVICE_GROUP, process.env.NEBULA_HOST_DOMAIN);

const TERMS_OF_USE_URL = 'https://bulletin.nebula.zyxel.com/data-policies/NCC_TermsOfUse_20180731.en-us.html';

// get MZC session
const appKey = process.env.MZC_OAUTH.app_key;
const mzcHost = process.env.MZC_OAUTH.desktop;
const LoginRedirect = `${location.protocol}//${location.host}/cc/index.html`;
const LogoutRedirect = `${location.protocol}//${location.host}/`;
const mzc = new MzcOAuthPortal(appKey, LoginRedirect, LogoutRedirect, mzcHost);

const Login = () => {
    console.info('login button pressed');
    mzc.login();
};

const SSO = () => {
    console.info('sso status check');
    const ssoImg = new Image();
    ssoImg.onload = function () {
        Login();
    };
    ssoImg.onerror = function () {
        document.querySelector('.main').classList.remove('oauth');
    };
    ssoImg.src = process.env.MZC_OAUTH.session_oauth;
};
SSO();

document.querySelector('#btn-login')?.addEventListener('click', Login);
const sessionData = window.sessionStorage.getItem('nebula://session/continuity');
if (sessionData && sessionData.includes('/wizard')) {
    Login();
}

const termsOfUserLink = document.querySelector('#termsOfUserLink');
const termsOfUserDialog = document.querySelector('#termsOfUserDialog');
const termsOfUseIframe = document.querySelector('#termsOfUseIframe');
const isTermsDialogSupported =
    typeof window.HTMLDialogElement !== 'undefined' &&
    typeof window.HTMLIFrameElement !== 'undefined' &&
    termsOfUserDialog instanceof window.HTMLDialogElement &&
    termsOfUseIframe instanceof window.HTMLIFrameElement;

if (isTermsDialogSupported) {
    termsOfUserLink?.addEventListener('click', () => {
        if (!termsOfUseIframe.src) {
            termsOfUseIframe.src = TERMS_OF_USE_URL;
        }
        if (!termsOfUserDialog.open) {
            termsOfUserDialog.showModal();
        }
    });

    termsOfUserDialog.querySelectorAll('[data-dialog-close]').forEach((closeButton) => {
        closeButton.addEventListener('click', () => {
            termsOfUserDialog.close();
        });
    });

    termsOfUserDialog.addEventListener('click', (event) => {
        if (event.target === termsOfUserDialog) {
            termsOfUserDialog.close();
        }
    });
}
